export default function Hero() {
  return (
    <section className="relative overflow-hidden pt-12 md:pt-16">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 py-8 md:py-14">
          <div className="w-full lg:w-1/2 bg-[#1E3A47] rounded-2xl p-8 md:p-12 text-white">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-4">
              Mentions légales
            </h1>
            <p className="text-base md:text-lg text-white/90 mb-8 leading-relaxed">
              Informations légales de l'éditeur du site.
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="tel:0374471036"
                className="bg-[#FF6B4A] text-white font-medium text-sm px-6 py-3 rounded-lg hover:bg-[#FF6B4A]/90 transition-colors whitespace-nowrap cursor-pointer text-center flex items-center justify-center gap-2"
              >
                <i className="ri-phone-line w-5 h-5 flex items-center justify-center" />
                Appeler le 03 74 47 10 36
              </a>
              <a
                href="/"
                className="border border-white/40 text-white font-medium text-sm px-6 py-3 rounded-lg hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer text-center"
              >
                Retour à l'accueil
              </a>
            </div>
          </div>
          <div className="w-full lg:w-1/2">
            <div className="rounded-2xl overflow-hidden h-64 md:h-80 lg:h-96">
              <img
                src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/270072d9fe20dda93c94f272f4415ced.jpeg"
                alt="Mentions légales document professionnel"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}